/**
 * These select* functions are for redux select(), they expose parts of the state.
 */

import { TreeStatus } from "./types"
import { RootState } from "../../../modules/store"

export const selectTreeStatus = (store: RootState): TreeStatus =>
  store.pages.exercisesPages.treeStatus
